import Footer from "../Components/Footer";
import Header from "../Components/Header";
import NewsComp from "../Components/NewsComp/NewsComp";

function NewsPage()
{
    return(
        <div>
            <Header/>
            <NewsComp/>
            <Footer/>
        </div>
    );
} 

export default NewsPage;